<!-- 采集器列表 -->
<template>
  <div class="app-container">
    <div class="app-content">
      <el-card class="energy-collector" shadow="never">
        <template slot="header">
          <el-form inline size="small">
            <el-form-item :label="$t('text.sbxlh')">
              <el-input
                v-model="queryParams.gatewaysn"
                clearable
              />
            </el-form-item>
            <el-form-item :label="$t('text.sbzt')">
              <el-select
                v-model="queryParams.status"
                clearable
                :placeholder="$t('placeholder.qxxsbzt')"
              >
                <el-option
                  v-for="item in statusOptions"
                  :key="item.label"
                  :label="$t(item.label)"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-button
                type="primary"
                icon="el-icon-search"
                @click="handleQuery"
              >{{ $t('button.cx') }}</el-button>
              <el-button
                type="primary"
                icon="el-icon-plus"
                @click="handleAdd"
              >{{ $t('button.tianjia') }}</el-button>
            </el-form-item>
          </el-form>
        </template>
        <template flot="default" />
        <el-table
          v-loading="loading"
          element-loading-spinner="el-icon-loading"
          element-loading-background="rgba(0, 0, 0, 0.8)"
          :data="tableData"
          height="calc(100% - 50px)"
          style="width: 100%"
        >
          <template #empty>
            <div class="table-no-data" />
          </template>
          <el-table-column
            align="center"
            width="90px"
            type="index"
            :index="indexCount"
            :label="$t('text.xh')"
          />
          <el-table-column
            align="center"
            :label="$t('text.zt')"
            prop="status"
          >
            <template v-slot="scope">
              <span>{{ scope.row.status | statusFilter }}</span>
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            :label="$t('text.sblx')"
            prop="gtype"
          >
            <template v-slot="scope">
              <span>{{ scope.row.gtype | gtypeFilter }}</span>
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            :label="$t('text.sbxlh')"
            prop="gatewaysn"
          />
          <el-table-column
            align="center"
            :label="$t('text.sbbm')"
            prop="alias"
            :formatter="$elFormatter"
          />
          <el-table-column
            align="center"
            :label="$t('text.dzmc')"
            prop="orgname"
            :formatter="$elFormatter"
          />
          <el-table-column
            align="center"
            :label="$t('text.fxs')"
            prop="distributor"
            :formatter="$elFormatter"
          />
          <el-table-column
            align="center"
            :label="$t('text.azs')"
            prop="installer"
            :formatter="$elFormatter"
          />
          <el-table-column
            align="center"
            :label="$t('text.zdyh')"
            prop="terminal"
            :formatter="$elFormatter"
          />
          <el-table-column
            align="center"
            :label="$t('text.cz')"
          >
            <template v-slot="scope">
              <el-button
                icon="el-icon-edit"
                size="small"
                type="text"
                @click="handleUpdate(scope.row)"
              >{{ $t('button.sz') }}</el-button>
              <el-button
                icon="el-icon-delete"
                size="small"
                type="text"
                class="danger"
                @click="handleDelete(scope.row)"
              >{{ $t('button.sc') }}</el-button>
            </template>

          </el-table-column>
        </el-table>
        <el-pagination
          :current-page.sync="pageNum"
          :page-size="pageSize"
          :total="total"
          background
          layout="total, prev, pager, next"
          @current-change="getTableData"
        />
      </el-card>
      <!-- 设置弹出框 -->
      <el-dialog
        :title="$t(dialogTitle)"
        :visible.sync="showUpdateDialog"
        width="600px"
        append-to-body
        :close-on-click-modal="false"
        :close-on-press-escape="false"
      >
        <el-form
          :model="deviceForm"
          label-width="100px"
        >
          <el-form-item :label="$t('text.sbbm')">
            <el-input
              v-model="deviceForm.alias"
              clearable
            />
          </el-form-item>
        </el-form>
        <div
          slot="footer"
          class="dialog-footer"
        >
          <el-button
            type="primary"
            @click="handleSubmit"
          >{{ $t('button.qd') }}</el-button>
          <el-button @click="showUpdateDialog = false">{{ $t('button.qx') }}</el-button>
        </div>
      </el-dialog>
      <el-dialog
        :title="$t(dialogAddTitle)"
        :visible.sync="showAddDialog"
        width="600px"
        append-to-body
        :close-on-click-modal="false"
        :close-on-press-escape="false"
      >
        <el-form
          :model="deviceForm"
          label-width="100px"
        >
          <el-form-item :label="$t('text.cjqxlh')">
            <el-input
              v-model="sn"
              clearable
            />
          </el-form-item>
        </el-form>
        <div
          slot="footer"
          class="dialog-footer"
        >
          <el-button
            type="primary"
            @click="handleAddSubmit"
          >{{ $t('button.qd') }}</el-button>
          <el-button @click="showAddDialog = false">{{ $t('button.qx') }}</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { QueryGateways, UpdateGateways } from '@apis/Device'
import { BindGatewayToStation, UnbindGateways } from '@/api/Stations'
export default {
  data () {
    return {
      queryParams: {
        status: '',
        gatewaysn: '',
        orgid: this.$store.getters.station.id,
        gtype: '1'
      },
      statusOptions: [
        { label: 'text.zhenc', value: '0' },
        { label: 'text.bfzx', value: '1' },
        { label: 'text.lx', value: '2' },
        { label: 'text.bj', value: '3' }
      ],
      devtypes: [
        { key: 'text.zc', value: '0' },
        { key: 'text.cn', value: '1' },
        { key: 'text.qx', value: '2' },
        { key: 'text.db', value: '3' },
      ],
      loading: false,
      tableData: [],
      total: 0,
      pageNum: 1,
      pageSize: 10,
      showUpdateDialog: false, // 设置弹框显隐，
      deviceForm: {}, // 修改设备的数据
      dialogTitle: 'text.xgsb', // 修改设备弹框框标题
      showAddDialog: false,
      dialogAddTitle: 'text.tjsb',
      sn: ''
    }
  },
  mounted () {
    this.getTableData()
  },
  methods: {
    handleAdd () {
      this.showAddDialog = true
    },
    handleAddSubmit () {
      BindGatewayToStation({
        id: this.$store.getters.station.id,
        tag: this.sn
      }).then(() => {
        this.$msgSuccess(this.$t('notice.tjsbcg'))
        this.getTableData()
        this.showAddDialog = false
      }).catch((err) => {
        throw new Error(err)
      })
    },
    // 序号
    indexCount (index) {
      return (this.pageNum - 1) * this.pageSize + (index + 1)
    },
    // 查询
    handleQuery () {
      this.pageNum = 1
      this.getTableData()
    },
    // 获取表格数据
    getTableData () {
      this.loading = true
      QueryGateways({
        page: this.pageNum,
        perPage: this.pageSize,
        orderBy: '',
        whereCondition: JSON.stringify(this.queryParams)
      })
        .then(res => {
          this.loading = false
          this.tableData = res.data.queryResults || []
          this.total = res.data.totalCount
        })
        .catch(() => {
          this.loading = false
        })
    },
    // 设备设置
    handleUpdate (row) {
      this.deviceForm = this.$deepClone(row)
      this.showUpdateDialog = true
    },
    // 设备删除
    handleDelete (row) {
      this.$confirm(this.$t('notice.sfjc'), this.$t('notice.title'), {
        confirmButtonText: this.$t('button.qr'),
        cancelButtonText: this.$t('button.qx'),
        type: 'warning'
      })
        .then(() => {
          return UnbindGateways({ ids: [row.id] })
        })
        .then(() => {
          this.$msgSuccess(this.$t('notice.jccg'))
          this.getTableData()
        })
        .catch(() => {})
    },
    // 弹框确定按钮
    handleSubmit () {
      UpdateGateways(this.deviceForm)
        .then(() => {
          this.$msgSuccess(this.$t('notice.xgsbcg'))
          this.getTableData()
          this.showUpdateDialog = false
        })
    }
  }
}
</script>
<style scoped>
.energy-collector {
  width: 100%;
  height: 100%;
  padding: 0;
  box-sizing: border-box;
  background-color: var(--card-bg-color);
  border-color: var(--card-bg-color);
}
.energy-collector>>> .el-card__header {
  width: 100%;
  height: 50px;
  padding: 0 20px;
  box-sizing: border-box;
}
.energy-collector>>> .el-card__header .el-form{
  width: 100%;
  height: 100%;
  padding: 0;
  box-sizing: border-box;
  display: flex;
  align-items: center;
}
.energy-collector>>> .el-card__header .el-form .el-form-item{
  margin-bottom: 0;
}

.energy-collector>>> .el-card__body {
  width: 100%;
  height: calc(100% - 50px);
  padding: 0 20px;
  box-sizing: border-box;
}
.energy-collector>>> .el-card__body .el-table {
  border: none;
}
.energy-collector>>> .el-card__body .el-pagination {
  width: 100%;
  height: 50px;
  padding: 0 20px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
.energy-collector>>> .el-card__body .el-table--border::after, .el-table--group::after, .el-table::before{
  background-color: transparent;
}
</style>

